import { jsx as _jsx } from "react/jsx-runtime";
import SelectCustomControlled from "./SelectCustomControlled.js";
import SelectCustomUncontrolled from "./SelectCustomUncontrolled.js";
const SelectCustom = (props) => {
    const { value } = props;
    if (value !== undefined) {
        return _jsx(SelectCustomControlled, { ...props });
    }
    return _jsx(SelectCustomUncontrolled, { ...props });
};
SelectCustom.displayName = "SelectCustom";
export default SelectCustom;
